import React from "react";
import {Box, IconButton, Popover, Tooltip, Typography} from "@mui/material";
import {Apps, Engineering} from "@mui/icons-material";
import {Blue3} from "../theme/styles";
import useBreakpoint from "../util/useBreakpoint";
import css_buttons from "../components/Common/css/CCButton.module.scss";
import {useNavigate} from "react-router-dom";


type MenuSelection = {id: string, target: EventTarget & HTMLButtonElement, option: string | null}

export default function Administration() {
    const [menu, setMenu] = React.useState<MenuSelection | null>(null);

    const navigate = useNavigate();
    const breakpoint = useBreakpoint();

    function renderAdministration() {
        let administration = null;
        if (breakpoint.getBreakPointName() === "xl") {
            administration = (
                <>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "space-evenly", height: "200px", marginTop: "20px"}}>
                        {1!==1 ? (
                            <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                                <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                    navigate("/administration/roles");
                                }}>
                                    <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                                </IconButton>
                                <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Roles</Typography>
                            </div>
                        ) : null}
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/positions");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Positions</Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/organizations");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Organizations</Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/usergroups");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>User Groups</Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/workgroups");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Work Groups</Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", width: "100px", marginLeft: "auto", marginRight: "auto"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/users");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Users</Typography>
                        </div>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "200px", marginTop: "20px"}}>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", width: "100px", marginLeft: "auto", marginRight: "auto"}}>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", width: "100px", marginLeft: "auto", marginRight: "auto"}}>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", width: "100px", marginLeft: "auto", marginRight: "auto"}}>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", width: "100px", marginLeft: "auto", marginRight: "auto"}}>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", width: "100px", marginLeft: "auto", marginRight: "auto"}}>
                        </div>
                    </div>
                </>
            )
        }
        if (breakpoint.getBreakPointName() === "lg") {
            administration = (
                <>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "space-evenly", height: "200px", marginTop: "20px"}}>
                        {1!==1 ? (
                            <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                                <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                    navigate("/administration/roles");
                                }}>
                                    <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                                </IconButton>
                                <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Roles</Typography>
                            </div>
                        ) : null}
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/positions");
                        }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Positions</Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/organizations");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Organizations</Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/usergroups");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>User Groups</Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", width: "100px", marginLeft: "auto", marginRight: "auto"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/workgroups");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Work Groups</Typography>
                        </div>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "200px", marginTop: "20px"}}>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", width: "100px", marginLeft: "auto", marginRight: "auto"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/users");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Users</Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", width: "100px", marginLeft: "auto", marginRight: "auto"}}>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", width: "100px", marginLeft: "auto", marginRight: "auto"}}>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", width: "100px", marginLeft: "auto", marginRight: "auto"}}>
                        </div>
                    </div>
                </>
            )
        }
        if (breakpoint.getBreakPointName() === "md") {
            administration = (
                <>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "space-evenly", height: "200px", marginTop: "20px"}}>
                        {1!==1 ? (
                            <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                                <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                    navigate("/administration/roles");
                                }}>
                                    <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                                </IconButton>
                                <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Roles</Typography>
                            </div>
                        ) : null}
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/positions");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Positions</Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/organizations");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Organizations</Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/usergroups");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>User Groups</Typography>
                        </div>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "200px", marginTop: "20px"}}>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/workgroups");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Work Groups</Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/users");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Users</Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", width: "100px", marginLeft: "auto", marginRight: "auto"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/users");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Users</Typography>
                        </div>
                    </div>
                </>
            )
        }
        if (breakpoint.getBreakPointName() === "sm") {
            administration = (
                <>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "space-evenly", height: "200px", marginTop: "20px"}}>
                        {1!==1 ? (
                            <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                                <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                    navigate("/administration/roles");
                                }}>
                                    <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                                </IconButton>
                                <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Roles</Typography>
                            </div>
                        ) : null}
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "50%"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/positions");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Positions</Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "50%"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/organizations");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Organizations</Typography>
                        </div>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "200px", marginTop: "20px"}}>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "50%"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/usergroups");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>User Groups</Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "50%"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/workgroups");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Work Groups</Typography>
                        </div>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "200px", marginTop: "20px"}}>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "50%"}}>
                            <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                navigate("/administration/users");
                            }}>
                                <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                            </IconButton>
                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Users</Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "50%"}}>
                        </div>
                    </div>
                </>
            )
        }
        if (breakpoint.getBreakPointName() === "xs") {
            administration = (
                <>
                    <div style={{display: "flex", flexDirection: "column", height: "200px", marginTop: "20px"}}>
                        {1!==1 ? (
                            <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                                <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                    navigate("/administration/roles");
                                }}>
                                    <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                                </IconButton>
                                <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Roles</Typography>
                            </div>
                        ) : null}
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "200px", marginTop: "20px"}}>
                            <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "100%"}}>
                                <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                    navigate("/administration/positions");
                                }}>
                                    <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                                </IconButton>
                                <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Positions</Typography>
                            </div>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "200px", marginTop: "20px"}}>
                            <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "100%"}}>
                                <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                    navigate("/administration/organizations");
                                }}>
                                    <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                                </IconButton>
                                <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Organizations</Typography>
                            </div>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "200px", marginTop: "20px"}}>
                            <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "100%"}}>
                                <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                    navigate("/administration/usergroups");
                                }}>
                                    <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                                </IconButton>
                                <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>User Groups</Typography>
                            </div>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "200px", marginTop: "20px"}}>
                            <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "100%"}}>
                                <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                    navigate("/administration/workgroups");
                                }}>
                                    <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                                </IconButton>
                                <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Work Groups</Typography>
                            </div>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "200px", marginTop: "20px"}}>
                            <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "100%"}}>
                                <IconButton className={css_buttons.blueIconButton} style={{height: "175px"}} onClick={() => {
                                    navigate("/administration/users");
                                }}>
                                    <Engineering sx={{color: Blue3, width: "150px", height: "150px"}}/>
                                </IconButton>
                                <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Users</Typography>
                            </div>
                        </div>
                    </div>
                </>
            )
        }

        return administration
    }

    return (
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: 52, backgroundColor: "#1498D8"}}>
                <div style={{paddingTop: "9px", paddingLeft: "20px"}}>
                    <Typography style={{fontSize: 24, fontWeight: 400, color: "#FFFFFF"}}>Administration</Typography>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", marginRight: "15px"}}>
                    <Tooltip title={"Administration Menu"}>
                        <IconButton className={css_buttons.blueIconButton2} style={{marginTop: "11px"}} onClick={(e) => setMenu({id: "administrationAppsMenu", target: e.currentTarget, option: null})}>
                            <Apps/>
                        </IconButton>
                    </Tooltip>
                    {menu?.id === "administrationAppsMenu" ? (
                        <Popover anchorEl={menu.target}
                                 anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                                 transformOrigin={{vertical: -11, horizontal: "left"}}
                                 open={true}
                                 onClose={() => setMenu(null)}
                                 TransitionProps={{
                                     onExited: () => setMenu(null),
                                 }}
                                 PaperProps={{
                                     elevation: 2,
                                 }}
                        >
                            <Box sx={{p: 2, bgcolor: "background.paper", width: "450px", height: "260px"}}>
                                <div style={{display: "flex", flexDirection: "column", padding: "10px"}}>
                                    <div style={{display: "flex", flexDirection: "row", alignContent: "space-between"}}>
                                        {1!==1 ? (
                                            <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "33%"}}>
                                                <IconButton className={css_buttons.blueIconButton} style={{height: "75px"}} onClick={() => {
                                                    setMenu(null)
                                                    navigate("/administration/roles");
                                                }}>
                                                    <Engineering sx={{color: Blue3, width: "150px", height: "75px"}}/>
                                                </IconButton>
                                                <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Roles</Typography>
                                            </div>
                                        ) : null}
                                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "33%"}}>
                                            <IconButton className={css_buttons.blueIconButton} style={{height: "75px"}} onClick={() => {
                                                setMenu(null)
                                                navigate("/administration/positions");
                                            }}>
                                                <Engineering sx={{color: Blue3, width: "150px", height: "75px"}}/>
                                            </IconButton>
                                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Positions</Typography>
                                        </div>
                                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "33%"}}>
                                            <IconButton className={css_buttons.blueIconButton} style={{height: "75px"}} onClick={() => {
                                                setMenu(null)
                                                navigate("/administration/organizations");
                                            }}>
                                                <Engineering sx={{color: Blue3, width: "150px", height: "75px"}}/>
                                            </IconButton>
                                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Organizations</Typography>
                                        </div>
                                    </div>
                                    <div style={{display: "flex", flexDirection: "row", alignContent: "space-between", marginTop: "20px"}}>
                                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "33%"}}>
                                            <IconButton className={css_buttons.blueIconButton} style={{height: "75px"}} onClick={() => {
                                                setMenu(null)
                                                navigate("/administration/usergroups");
                                            }}>
                                                <Engineering sx={{color: Blue3, width: "150px", height: "75px"}}/>
                                            </IconButton>
                                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>User Groups</Typography>
                                        </div>
                                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "33%"}}>
                                            <IconButton className={css_buttons.blueIconButton} style={{height: "75px"}} onClick={() => {
                                                setMenu(null)
                                                navigate("/administration/workgroups");
                                            }}>
                                                <Engineering sx={{color: Blue3, width: "150px", height: "75px"}}/>
                                            </IconButton>
                                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Work Groups</Typography>
                                        </div>
                                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "33%"}}>
                                            <IconButton className={css_buttons.blueIconButton} style={{height: "75px"}} onClick={() => {
                                                setMenu(null)
                                                navigate("/administration/users");
                                            }}>
                                                <Engineering sx={{color: Blue3, width: "150px", height: "75px"}}/>
                                            </IconButton>
                                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Users</Typography>
                                        </div>
                                    </div>
                                </div>
                            </Box>
                        </Popover>
                    ) : null}
                </div>
            </div>
            {renderAdministration()}
        </div>
    );
}